.control {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.select {
  composes: input from '../TextField/TextField.module.css';
  appearance: none;
  padding-right: 32px;
  cursor: pointer;
}

.chevron {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--color-text-muted);
  pointer-events: none;
}

.lg .select {
  min-height: var(--control-height-lg);
  padding: 12px 32px 12px 14px;
  font-size: var(--text-md);
}

.invalid {
  composes: invalid from '../TextField/TextField.module.css';
}
